// extracted by mini-css-extract-plugin
module.exports = {"MessageFullPageContainer":"NoItemsMessage_MessageFullPageContainer__wRlhm","MessageAbsoluteContainer":"NoItemsMessage_MessageAbsoluteContainer__1XaT6"};